import { ToastContainer } from 'react-toastify';
import './App.css';
import store from './Redux/store';
import AppRoutes from './Routes/routes';
// import { store } from "../src/Redux/store.js";
import { Provider } from 'react-redux';


function App() {
  return (
   <>
   <Provider store={store}>
      <AppRoutes/>
   </Provider>
   </>
  );
}

export default App;
